import styles from './style.module.css';
import icPickup from '../../../../assets/ic-pickup.svg';
import icSchedule from '../../../../assets/ic-schedule-x.svg';
import momentJalaali from "moment-jalaali";
import { checkTimestamp, get_lang } from "../../../../helper/UserData/userdate";
import { useTranslation } from 'react-i18next';
import Typography from '../../../../design-system/lib/Typography';
import { Pickupp } from '../../../../assets';
const _ = require('lodash');

export const PickupRow = ({ data }) => {
    const { t, i18n } = useTranslation();

    if (_.isEmpty(data.pickup)) {
        return null
    }

    return <div className={styles.PickupRowContainer}>
         <img src={Pickupp}  className={styles.PickupRowImageIcon} />
        <Typography weight='Body_Small_Regular' text={data.pickup.locationType == "address" ? data.pickup.address : data.pickup.servicePoint?.name} className={styles.PickupRowAddress} />
        {(data.pickup.scheduleDateAfter != 0 || data.pickup.scheduleDateBefore != 0) &&
            <span className={styles.PickupRowSchedule}>
                 <Typography weight='Body_Small_Regular' text={momentJalaali(data.pickup.scheduleDateAfter || data.pickup.scheduleDateBefore).locale(get_lang()).format(checkTimestamp(data.pickup.scheduleDateAfter || data.pickup.scheduleDateBefore))} className={styles.PickupRowScheduleText} />

            </span>

        }
        {["Pickup", "PickupDelivery"].indexOf(data.type) > -1 &&
            <>
                {data.isPickupDelivery && <span className={styles.OrderTypePD}> {t("tab_PickupDelivery")}</span>}
                {data.type == "Pickup" && <span className={data.isPickupDelivery ? styles.OrderTypewithPD : styles.OrderType}> {t("PickupFlag")} </span>}
            </>
        }
        {/* <span className={styles.OrderType}> P </span> */}


    </div>
};




